<div class="blocked-container width-660" tracking formname="Smart invest line simulation"
    stepname="{{screenLabels.adobeStepName}}" submittrigger="{{screenLabels.adobeSubmittrigger}}" stepclusterOptional="stop">
    <div class="blocked-intro-text" [innerHTML]="screenLabels.tipTitle | translate | punctuationWrap"></div>
    <h2 class="blocked-title" [innerHTML]="screenLabels.title | translate: { Name: this.dynamicField_firstPara } | punctuationWrap"></h2>
    <!-- <h2 class="blocked-title">{{ screenLabels.title | translate:{firstname: firstName, partnerName: partnerName} }}</h2> -->
    <!--<div class="blocked-image">
        <div id="jsonImageIcon" class="lottie blocked-large-image"></div>
    </div>-->
    <div class="json-container {{customImgCss}}" [class.blocked-large-image]="isImageLarge"
        [class.blocked-full-width]="isImageFullWidth" [class.json-container]="screenLabels.imageUrl.includes('json')" [class.svg-container]="screenLabels.imageUrl.includes('svg')">
        <ng-container *ngIf="screenLabels.imageUrl.includes('json')">
            <div id="jsonImageIcon" class="lottie" style="width:350px;"></div>
        </ng-container>
        <ng-container *ngIf="screenLabels.imageUrl.includes('svg')">
            <div id="jsonImageIcon"><img src="{{screenLabels.imageUrl}}" alt=""></div>
        </ng-container>
        
    </div>
    <ng-container *ngIf="(this.currentBlockedContext !== RouteNames.BlockedExpiredIdentification)">
        <div class="blocked-content" [innerHTML]="screenLabels.desc | translate: { Name: this.dynamicField_secondPara } | punctuationWrap"></div>
    </ng-container>
    <ng-container *ngIf="(this.currentBlockedContext === RouteNames.BlockedExpiredIdentification)">
        <div class="blocked-content">
            <span [innerHTML]="'BlockedScreen.Blocked-Expired-ID.Block-Text-1' | translate | punctuationWrap"></span>
            <a (click)="handleNavigation()" class="blocked-link" [innerHTML]="'BlockedScreen.Blocked-Expired-ID.Block-Text-link' | translate | punctuationWrap"></a>
            <span [innerHTML]="'BlockedScreen.Blocked-Expired-ID.Block-Text-2' | translate | punctuationWrap"></span>
        </div>
    </ng-container>
    
</div>
<app-cta-container [primaryBtnLabel]="screenLabels.ctaText | translate: { Name: this.dynamicField_PrimaryBtnText }"
    [secondaryBtnLabel]="screenLabels.secondaryCtaText | translate"
    [isPrimaryBtnBlue]="screenLabels.isPrimaryBtnBlue"
    [isSecondaryBtnHidden]="!screenLabels.isSecondaryButtonVisible" [isPrimaryBtnHidden]="PrimaryBtnHidden" (actionSelected)="nextAction($event)"
    adobeSubmitTriggerClass='ab-unknown-partner-block'>
</app-cta-container>
